import React from 'react';
import {H2} from '../../../components/crousal/Headings';
import {Button, ButtonSize, ButtonType} from '../../../components/crousal/Button';
import {ACCOUNTS} from '../../../common/constants/accounts';

interface IProps {
    onChange: (step: number) => void;
    availableAccountType: (account: string) => void;
}

export function Step1({onChange, availableAccountType}: IProps) {
    function handleSelect(accountType: string) {
        availableAccountType(accountType);
        onChange(2);
    }

    return (
        <div>
            <H2 className="mt-6 lg:mt-10">Step 1 - Type of the account you want to sell</H2>
            <div className="items-center lg:mt-16 flex justify-center lg:w-1/2 lg:mx-auto text-center">
                <div className="mb-4 h-full text-left p-4 lg:w-2/5 lg:mx-auto bg-medium-black">
                    Package account
                    <div className="text-xs mt-2">
                        An account without a lot of cosmetic content unlocked or without any rare skins.
                    </div>
                    <div className="flex-1 mt-6 border-t border-metallic-grey"/>
                    <div className="text-xs text-30 mt-4">
                        A good example would be ranked smurfs, Champion accounts with only few skins. Accounts like this
                        sell faster on average.
                    </div>
                    <div className="text-sm mt-4 flex justify-center text-center">
                        <Button type={ButtonType.DEFAULT} size={ButtonSize.SMALL}
                                onClick={() => handleSelect(ACCOUNTS.package)}>
                            Select
                        </Button>
                    </div>
                </div>

                <div className="mb-4 h-full text-left lg:w-2/5 lg:mx-auto p-4 bg-medium-black">
                    High-End account
                    <p className="text-xs mt-2">
                        An account with a lot of cosmetic content unlocked (20+ skins at least) or with rare skins
                        <span className="text-smurfs-gold cursor-pointer"> (Read here what is rare)</span>
                    </p>
                    <div className="flex-1 mt-4 border-t border-metallic-grey"/>
                    <div className="text-xs text-30 mt-4">
                        Accounts like this sell like this take longer to sell on average, but sell for a higher price.
                    </div>
                    <div className="text-sm mt-6 flex justify-center text-center">
                        <Button type={ButtonType.DEFAULT} size={ButtonSize.SMALL}
                                onClick={() => handleSelect(ACCOUNTS.highEnd)}>
                            Select
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
